export const environment = {
    isProduction: false,
    version: '0.9.31',

    api: 'https://dev-ac-api.officemaps.dev',
    authority: 'https://login.officemaps.dev'
};
